<template>
    <section>
        <div>
            <div class="title">
                Tic-Tac-Toe
            </div>
            <p>
                Battle against a terrible AI to see who can win a game of tic-tac-toe!
            </p>
            <p>{{ gameMessage }}</p>
            <div id="board">
                <button @click="claim(0)" id="cell0" class="cell">{{ cells[0] }}</button>
                <button @click="claim(1)" id="cell1" class="cell">{{ cells[1] }}</button>
                <button @click="claim(2)" id="cell2" class="cell">{{ cells[2] }}</button>
                <button @click="claim(3)" id="cell3" class="cell">{{ cells[3] }}</button>
                <button @click="claim(4)" id="cell4" class="cell">{{ cells[4] }}</button>
                <button @click="claim(5)" id="cell5" class="cell">{{ cells[5] }}</button>
                <button @click="claim(6)" id="cell6" class="cell">{{ cells[6] }}</button>
                <button @click="claim(7)" id="cell7" class="cell">{{ cells[7] }}</button>
                <button @click="claim(8)" id="cell8" class="cell">{{ cells[8] }}</button>
            </div>
        </div>
        <button @click="reset" id="reset-button" class="button">Play Again!</button>
    </section>
</template>

<script>
import Vue from 'vue'

export default {
    name: 'Tic-Tac-Toe',
    data() {
        return {
            cells: ['','','','','','','','',''],
            gameDisabled: false,
            gameMessage: "Click a box to start a game!"
        }
    },
    methods: {
        activateRestart: function() {
            document.getElementById("reset-button").style.visibility = "visible";
        },
        aiTurn: function() {
            let count = 0
            for (let i = 0; i < this.cells.length; i++) {
                if (this.cells[i] === '') {
                    count++;
                }
            }
            const selectedCell = Math.floor( Math.random()*count );
            count = 0;
            for (let i = 0; i < this.cells.length; i++) {
                if (this.cells[i] === '') {
                    if (count === selectedCell) {
                        Vue.set(this.cells, i, 'O');
                    }
                    count++;
                }
            }
            /*for (let i = 0; i < this.cells.length; i++) {
                if (this.cells[i] === '') {
                    Vue.set(this.cells, i, 'O');
                    break;
                }
            }*/
            this.checkForWinner();
        },
        checkForWinner: function() {
            if (this.cells[0] === this.cells[1] && this.cells[1] === this.cells[2] && this.cells[0] !== "") {
                this.declareWinner([0,1,2]);
            } else if (this.cells[3] === this.cells[4] && this.cells[4] === this.cells[5] && this.cells[3] !== "") {
                this.declareWinner([3,4,5]);
            } else if (this.cells[6] === this.cells[7] && this.cells[7] === this.cells[8] && this.cells[6] !== "") {
                this.declareWinner([6,7,8]);
            } else if (this.cells[0] === this.cells[3] && this.cells[3] === this.cells[6] && this.cells[0] !== "") {
                this.declareWinner([0,3,6]);
            } else if (this.cells[1] === this.cells[4] && this.cells[4] === this.cells[7] && this.cells[1] !== "") {
                this.declareWinner([1,4,7]);
            } else if (this.cells[2] === this.cells[5] && this.cells[5] === this.cells[8] && this.cells[2] !== "") {
                this.declareWinner([2,5,8]);
            } else if (this.cells[0] === this.cells[4] && this.cells[4] === this.cells[8] && this.cells[0] !== "") {
                this.declareWinner([0,4,8]);
            } else if (this.cells[2] === this.cells[4] && this.cells[4] === this.cells[6] && this.cells[2] !== "") {
                this.declareWinner([2,4,6]);
            } else if (this.cells.every( (val) => val !== "" )) {
                this.gameMessage = "It's a tie!";
                this.gameDisabled = true;
                this.activateRestart();
            } else {
                this.gameMessage = "Game in Progress";
                return true;
            }
        },
        claim: function(cell) {
            if (this.gameDisabled === true ) return
            if (this.cells[cell] === "") {
                Vue.set(this.cells, cell, 'X')
                const gameInProgress = this.checkForWinner();
                if (gameInProgress) {
                    this.aiTurn();
                }
            }
        },
        declareWinner: function(winningCells) {
            this.gameDisabled = true;
            winningCells.forEach(cell => {
                document.getElementById(`cell${cell}`).style.background = "mediumspringgreen";
            });
            this.activateRestart();
            if (this.cells[winningCells[0]] === "X") {
                this.gameMessage = "You Win!";
            } else {
                this.gameMessage = "You Lose!";
            }
        },
        reset: function() {
            this.cells = ['','','','','','','','',''];
            for(let i = 0; i < this.cells.length; i++) {
                document.getElementById(`cell${i}`).style.background = "aliceblue";
            }
            document.getElementById("reset-button").style.visibility = "hidden";
            this.gameDisabled = false;
            this.gameMessage = "Click a box to start a game!";
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
    margin-bottom: 10px;
    text-align: center;
}

#board {
    display: inline-grid;
    grid-template-columns: repeat(3, 20vmin);
    grid-template-rows: repeat(3, 20vmin);
    grid-gap: 1vmin;
}
#reset-button {
    visibility: hidden;

    margin-top: 10px;
    border-radius: 10px;

    font-family: 'Verdana';
    font-size: 1rem;
    font-weight: 600;
}

.cell {
    background: aliceblue;
    border-radius: 6px;

    font-family: 'Verdana';
    font-size: 4rem;
    font-weight: 600;
}
</style>
